import { useApiPvpApplicationsRetrieve } from "@/api/lctApIComponents";
import { useAppSelector } from "@/hooks/reduxHooks";
import React from "react";

interface IProps {
  pvpId: string;
  appId: string;
}

export const PVPFormTitle: React.FC<IProps> = ({ appId, pvpId }) => {
  const token = useAppSelector((state) => state.user.authKey);

  const { data } = useApiPvpApplicationsRetrieve({
    headers: { Authorization: `Token ${token}` },
    pathParams: { id: appId, pvp: pvpId },
  });

  return (
    <section className="flex w-auto flex-grow flex-col rounded-lg border border-slate-300 bg-white p-6">
      <div className="prose w-full min-w-full flex-col">
        <h2 className="my-4 mt-0 align-top font-semibold text-gray-900">{data?.sub_title}</h2>
        <h3 className="my-4 mt-0 align-top">{data?.description}</h3>
        <h5 className="my-4 mt-0 align-top">{data?.additional_text}</h5>
        <h5 className="my-4 mt-0 align-top">
          <span className="text-error">*</span> Some questions require a reply and are denoted with a red asterisk.
        </h5>
      </div>
    </section>
  );
};
